/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Tue Mar 26 2024
 **/

import { atom } from "jotai";
import { BaseService } from "@/frameworks/libraries/restservice";

class AudioZone extends BaseService {
	constructor() {
		super();
	}

	private _APIPath = "/api/audio-zone";

	private static Cache = {
		End: atom<WebServices.AudioZone.End.Response>({}),
		Inquiry: atom<WebServices.AudioZone.Inquiry.Response>({}),
		Create: atom<WebServices.AudioZone.Create.Response>({}),
		CreateChat: atom<WebServices.AudioZone.CreateChat.Response>({}),
		Leave: atom<WebServices.AudioZone.Leave.Response>({}),
		Join: atom<WebServices.AudioZone.Join.Response>({}),
		JoinChat: atom<WebServices.AudioZone.JoinChat.Response>({})
	};

	public end = (name: string, events: API.Events) => ({
		name,
		events,
		callback: (parameter: WebServices.AudioZone.End.Request) =>
			this.delete(`${this._APIPath}/${parameter.audioZoneId}/end`),
		cache: AudioZone.Cache.End
	});

	public inquiry = (name: string, events: API.Events) => ({
		name,
		events,
		callback: (parameter: WebServices.AudioZone.Inquiry.Request) =>
			this.get(`${this._APIPath}/${parameter.audioZoneId}`),
		cache: AudioZone.Cache.Inquiry
	});

	public create = (name: string, events: API.Events) => ({
		name,
		events,
		callback: () => this.post(this._APIPath),
		cache: AudioZone.Cache.Create
	});

	public createChat = (name: string, events: API.Events) => ({
		name,
		events,
		callback: (parameter: WebServices.AudioZone.CreateChat.Request) =>
			this.post(`${this._APIPath}/${parameter.audioZoneId}/room`),
		cache: AudioZone.Cache.CreateChat
	});

	public leave = (name: string, events: API.Events) => ({
		name,
		events,
		callback: (parameter: WebServices.AudioZone.Leave.Request) =>
			this.post(`${this._APIPath}/${parameter.audioZoneId}/leave`),
		cache: AudioZone.Cache.Leave
	});

	public join = (name: string, events: API.Events) => ({
		name,
		events,
		callback: (parameter: WebServices.AudioZone.Join.Request) =>
			this.post(`${this._APIPath}/${parameter.audioZoneId}/join`),
		cache: AudioZone.Cache.Join
	});

	public join_chat = (name: string, events: API.Events) => ({
		name,
		events,
		callback: (parameter: WebServices.AudioZone.JoinChat.Request) =>
			this.post(`${this._APIPath}/${parameter.audioZoneId}/join_chat`),
		cache: AudioZone.Cache.JoinChat
	});
}

const AudioZoneService = new AudioZone();
export default AudioZoneService;
